import React, {Component} from 'react'
import PropTypes from "prop-types";
import Error from "../single_components/Error";
import SvGraphics from "../../assets/SvGraphics";
import PatientICDSelectComponent from "../single_components/PatientICDSelectComponent";

class VisitSummaryFirstBlock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry:this.props.entry,
            medical_diagnose_icd:this.props.medical_diagnose_icd
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry,
            })
        }
    }

    componentDidMount() {
    }

    render() {
        let {t} = this.props

        let {entry,medical_diagnose_icd}=this.state
        let medical_diagnose=[medical_diagnose_icd.length]
        for(let i=0;i<medical_diagnose_icd.length;i++){
            medical_diagnose[i]={value:medical_diagnose_icd[i].ICD_diagnosis_id, label:medical_diagnose_icd[i].Diagnosis_description}
        }

        return (
            <div className={'patientsFormBoxes-visitSummary'}>

                <div className={'patientsFormRow-high'}>
                    <div className={'inputSlotsDoc-full'}>
                        <label className={'infoLabel'}>{t('patient_boarding.visit_summury')}*</label>
                        <Error isShown={!!(this.props.errors)['visit_summary']} errorMessage={(this.props.errors)['visit_summary']}/>

                        <textarea  className={'info-inputBoxStyle-visitSummary boxMargin'} defaultValue={entry.visit_summary} maxLength={"5000"}
                                   onChange={(event) => this.props.onValueChange("visit_summary", event.target.value)}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                <div className={'inputSlotsHalfBlock-icd'}>
                        <label className={'infoLabel'}>{t('patient_boarding.medical_diagnoses_icd_name')}</label>
                        <PatientICDSelectComponent
                            selectWidth={'700px'}
                            placeholder={t('patient_boarding.icd_choose')}
                            options={medical_diagnose}
                            value={entry.medical_diagnoses_icd_name}
                            onChange={this.props.handleMedicalDiagnoseChange.bind(this)}
                        />
                    </div>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.medical_diagnoses_icd_code')}</label>
                        <input className={'inputBoxStyle'} name="medical_diagnoses_icd_code" value={entry.medical_diagnoses_icd_code}
                               onChange={(event) => this.props.onChangeDiagnoseCode(event.target.value,event.target.name,"medical_diagnoses_icd_name")}/>
                    </div>
                    <div className={'inputSlots'} style={{display:entry.medical_diagnoses_icd_name && entry.medical_diagnoses_icd_name.value===155?'block':'none'}}>
                        <label className={'infoLabel'}>{t('patient_boarding.other')}</label>
                        <input className={'inputBoxStyle'} name="medical_diagnoses_icd_code" value={entry.other_diagnoses}
                               onChange={(event) => this.props.onValueChange("other_diagnoses",event.target.value)}/>
                    </div>
                </div>

                <div className={'svg-label'} style={{display: !this.props.isOtherPsychiatricDiagnosis?'flex':'none'}}>
                    <SvGraphics className={"delete-icon"} svgname={'add-icon'} onClick={() => this.props.addOtherMedicalDiagnosis()}/>
                    <div className={'addTarget'} onClick={() => this.props.addOtherMedicalDiagnosis()}>{t('patient_boarding.add_medical_icd')}</div>
                </div>

                <div className={'svg-label'} style={{display: this.props.isOtherPsychiatricDiagnosis?'flex':'none'}}>
                      <SvGraphics className={"delete-icon"} svgname={'delete-icon'} onClick={() => this.props.deleteOtherMedicalDiagnosis()}/>
                    <div className={'addTarget'} onClick={() => this.props.deleteOtherMedicalDiagnosis()}>{t('patient_boarding.delete_medical_icd')}</div>
                </div>


                <div className={'patientsFormRow'} style={{display: this.props.isOtherPsychiatricDiagnosis?'flex':'none'}}>
                    <div className={'inputSlotsHalfBlock-icd'}>
                        <label className={'infoLabel'}>{t('patient_boarding.medical_diagnoses_icd_name')}</label>
                        <PatientICDSelectComponent
                            selectWidth={'700px'}
                            placeholder={t('patient_boarding.icd_choose')}
                            options={medical_diagnose}
                            value={entry.Another_Medical_diagnoses_icd_name}
                            onChange={this.props.handleAnotherMedicalDiagnoseChange.bind(this)}
                        />
                    </div>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.medical_diagnoses_icd_code')}</label>
                        <input className={'inputBoxStyle'} name="Another_Medical_diagnoses_icd_code" value={entry.Another_Medical_diagnoses_icd_code}
                               onChange={(event) => this.props.onChangeDiagnoseCode(event.target.value,event.target.name,"Another_Medical_diagnoses_icd_name")}/>
                    </div>
                    <div className={'inputSlots'}
                         style={{display:entry.Another_Medical_diagnoses_icd_name && entry.Another_Medical_diagnoses_icd_name.value===155?'block':'none'}}>
                        <label className={'infoLabel'}>{t('patient_boarding.other')}</label>
                        <input className={'inputBoxStyle'} name="medical_diagnoses_icd_code" value={entry.another_other_diagnoses}
                               onChange={(event) => this.props.onValueChange("another_other_diagnoses",event.target.value)}/>
                    </div>
                </div>

            </div>

        )
    }
}

VisitSummaryFirstBlock.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    onClickCheckboxes:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    checkboxes: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default VisitSummaryFirstBlock;
